module.exports = __webpack_public_path__ + "img/20190523194041微信截图_20190523194337.df635e7d.png";